import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { CertificateConfigForm } from "../../../components/reportConfig/form/CertificateConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import { ReportType } from "../../../models/enums/reportType";
import type { Group } from "../../../models/group";
import type { CertificateConfiguration } from "../../../models/reportConfigs/certificateConfiguration";
import type { Signature } from "../../../models/signature";
import type { YearContext } from "../../../models/yearContext";
import { report_configurations_path } from "../../../routes";

type CertificateConfigDuplicateProps = {
  certificate_config: CertificateConfiguration;
  year_contexts: YearContext[];
  groups: Group[];
  signatures: Signature[];
};

export default function CertificateConfigDuplicate({
  year_contexts,
  groups,
  certificate_config,
  signatures,
}: CertificateConfigDuplicateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(report_configurations_path), values);

  return (
    <ContentShell
      title={`Zertifikat-Vorlage ${certificate_config.title}`}
      onBack={() => router.get(pathWithYearContext(report_configurations_path))}
    >
      <CertificateConfigForm
        certificateConfig={certificate_config}
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Erstellen"
        onSubmit={onSubmit}
        reportType={ReportType.CERT}
        signatures={signatures}
      />
    </ContentShell>
  );
}
